import apiUrl from 'common/api-url';

App.Collections.Checkouts = BackboneEx.Collection.UrlFilter.extend({
  defaults: {},
  model: App.Models.Checkout,

  parse: function parse(data) {
    return data;
  },

  filters: {
    venueCustomerId: null,
    date: null,
    checkoutIds: null,
  },

  filterMap: {
    venueCustomerId: 'venueCustomerId',
    date: 'date',
    checkoutIds: 'checkoutIds',
  },
  hasRequiredFilters: function hasRequiredFilters() {
    const { venueCustomerId, date, checkoutIds } = this.filters;
    // url-template expands [null], [''] and ['  '] to the empty checkoutIds= this guard exists to stop.
    const usable = (id) => id != null && String(id).trim() !== '';
    const hasCheckoutIds = Array.isArray(checkoutIds)
      ? checkoutIds.some(usable)
      : usable(checkoutIds);

    return hasCheckoutIds || Boolean(venueCustomerId && date);
  },

  addNewCheckouts: function addNewCheckouts(models) {
    const known = this.map(function (checkout) {
      return checkout.getCheckoutId();
    });

    this.add(
      (models || []).filter(function (checkout) {
        return !known.includes(checkout.getCheckoutId());
      }),
    );
  },

  url: function url() {
    return apiUrl('CHECKOUTS', this.filters);
  },
});
